import Api from "./Api";
import Csrf from "./Csrf";

export default {
	
	async index() {
		await Csrf.getCookie();
		
		return Api.get("/workjobs");
	},
	
	async store(form) {
		await Csrf.getCookie();
		
		return Api.post("/workjobs",form);
	},

	async update(id,form) {
		await Csrf.getCookie();
		
		return Api.put("/workjobs/"+id,form);
	},

	async delete(id) {
		await Csrf.getCookie();
		
		return Api.delete("/workjobs/"+id);
	},
	
};